const rhFunction = {
    effectChipBet: (
        htmlString: string,
        listChip: any[],
        placeEl: HTMLElement,
        typeBet: 'RONG' | 'HO' | 'HOA',
        chipValue: number,
        scale: number
    ) => {
        let chipActiveEl = listChip.find((chipEl: HTMLButtonElement) => {
            return Number(chipEl.getAttribute('datatype')) === chipValue;
        });
        chipActiveEl = chipActiveEl.getBoundingClientRect();
        const coordinatesEl = placeEl.getBoundingClientRect();

        const cloneChip = document.createElement('div');
        cloneChip.innerHTML = htmlString;
        cloneChip.setAttribute('data-typebet', typeBet);
        cloneChip.classList.add('chipEmbed');
        cloneChip.style.left = `${chipActiveEl.left - coordinatesEl.left}px`;
        cloneChip.style.top = `${chipActiveEl.top - coordinatesEl.top}px`;
        cloneChip.style.width = chipActiveEl.width + 'px';
        cloneChip.style.height = chipActiveEl.width + 'px';
        placeEl.append(cloneChip);

        setTimeout(() => {
            cloneChip.style.transform = `scale(${scale})`;
            cloneChip.style.left = `${coordinatesEl.width / 2 - chipActiveEl.width / 2}px`;
            cloneChip.style.top = `${coordinatesEl.height / 2 - chipActiveEl.width / 2}px`;
        }, 10);

        // setTimeout(() => {
        //     cloneChip.remove();
        // }, 290);
    },
    collideCircle: (
        circle1: {
            x: number;
            y: number;
            radius: number;
        },
        circle2: {
            x: number;
            y: number;
            radius: number;
        }
    ) => {
        const distanceX = circle1.x - circle2.x;
        const distanceY = circle1.y - circle2.y;
        const radiiSum = circle1.radius + circle2.radius;
        console.log(distanceX, distanceY, radiiSum);
        return distanceX * distanceX + distanceY * distanceY <= radiiSum * radiiSum;
    },

    playAudio: (url: string) => {
        const audio = new Audio(url);
        audio.pause();
        audio.currentTime = 0;
        audio.play();
    },
};

export const chatSuggestRongHo = [
    'Rồng mạnh tay',
    'Hổ mạnh tay',
    'Gãy cầu rồi',
    'Húp trọn!!',
    'Bú xỉu tiếp',
    'Nay đen vãi',
    'Ai kéo em vào bờ với',
    'Cầu đẹp zô thôi!!',
    'Anh đi rút tiền đây^^',
    'Đánh Rồng ra Hổ:(',
    'Yêu ad vl',
];

export default rhFunction;
